import { render, staticRenderFns } from "./SystemMonitor.vue?vue&type=template&id=3a7c6491"
import script from "./SystemMonitor.vue?vue&type=script&lang=ts"
export * from "./SystemMonitor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports